import React from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';
import Dropzone from 'react-dropzone';
import { Field } from 'redux-form';

import FormError from './FormError';
import Wysiwyg from './Wysiwyg';

const getValidationState = meta => {
  if (meta.touched) {
    if (meta.valid === false) {
      return 'error';
    }
    if (meta.warning) {
      return 'warning';
    }
    if (meta.valid === true) {
      // return 'success';
    }
  }

  return null;
};

const Input = (
  {
    input,
    label,
    type,
    meta,
    labelStyle,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel style={ labelStyle || {}}>{label}</ControlLabel>}
    <div className="form-container">
      <FormControl {...input} type={type} {...props} />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Select = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <FormControl {...input} componentClass="select" {...props} />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Select2 = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <ReactSelect
        {...props}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
      />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const AsyncSelect = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <ReactSelect.AsyncCreatable
        {...props}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
        simpleValue
      />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const Creatable = (
  {
    input,
    label,
    type,
    meta,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      <ReactSelect.Creatable
        {...props}
        value={input.value}
        onChange={input.onChange}
        onBlur={() => input.onBlur(input.value)}
      />
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const InputGroup = (
  {
    input,
    label,
    type,
    meta,
    children,
    ...props
  }
) => (
  <FormGroup controlId={input.name} validationState={getValidationState(meta)}>
    {label && <ControlLabel>{label}</ControlLabel>}
    <div className="form-container">
      {children}
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

const FileInput = (
  {
    input,
    name,
    meta,
    change
  }
) => {
  const files = input.value;
  const handleDrop = filesToUpload => {
    const filenames = filesToUpload.map(f =>
      f.name.substring(0, f.name.lastIndexOf('.')));
    change('filenames', filenames);
    input.onChange(filesToUpload);
  };
  return (
    <div>
      <Dropzone name={name} onDrop={handleDrop} className="fileupload-drop">
        <span>Upload Files</span>
      </Dropzone>
      {meta.touched &&
        meta.error &&
        <span className="error">{meta.error}</span>}
    </div>
  );
};

const Switch = (
  {
    input,
    label,
    meta,
    required,
    help,
    className,
    ...props
  }
) => (
  <FormGroup
    controlId={input.name}
    validationState={getValidationState(meta)}
    className={className}
  >
    {label &&
      <ControlLabel
        bsClass={required ? 'control-label required' : 'control-label'}
      >
        {label}
      </ControlLabel>}
    <div className="form-container">
      <label className="switch">
        <FormControl
          type={props.type || 'checkbox'}
          {...input}
          {...props}
          checked={input.value === true}
        />
        <div className="switch-slider" />
      </label>
      {/*help && <HelpBlock>{help}</HelpBlock>*/}
      {meta.touched &&
        (meta.error || meta.warning) &&
        <FormError message={meta.error || meta.warning} />}
    </div>
  </FormGroup>
);

export default {
  Input,
  InputGroup,
  Select,
  Select2,
  Creatable,
  FileInput,
  AsyncSelect,
  Switch,
  Wysiwyg
};



// WEBPACK FOOTER //
// ./src/components/forms/FormField.js